import { render, staticRenderFns } from "./AnnouncementTable.vue?vue&type=template&id=648b9ee5&scoped=true&"
import script from "./AnnouncementTable.vue?vue&type=script&lang=js&"
export * from "./AnnouncementTable.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementTable.vue?vue&type=style&index=0&id=648b9ee5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648b9ee5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VIcon,VSimpleTable})
